import React,{useState} from 'react';
import {useNavigate} from 'react-router';






const Home = () => {
  var history=useNavigate();
    const [value,setValue]=useState("")
  
  return (
    <div id="Home">
      <h1>Home</h1>
      <center><input placeholder="Cars" id="searchbox" style={{"width":300,"height":40}} onChange={(e)=>setValue(e.target.value)} type="search"/></center>
      <center><br/>
     
    <button id="search-btn" onClick={()=>value&& history(`/search/${value}`)}></button>
      </center>
     </div>
  )
  }

export default Home
